import type { FC, InputHTMLAttributes, ReactNode } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string
    label: string
    hint?: ReactNode
    error?: string | null
}

const Field: FC<FieldProps> = ({ id, label, hint, error, className, ...props }): ReactNode => {
    return (
        <div className='space-y-2'>
            <Label htmlFor={id} className='text-[13px] text-slate-200'>
                {label}
            </Label>
            <Input
                id={id}
                aria-invalid={error ? true : undefined}
                aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
                className={cn('h-11 rounded-xl border-white/10 bg-white/[0.03] px-3.5 text-[15px] placeholder:text-slate-500 focus-visible:border-brand-violet/60 focus-visible:ring-brand-violet/25', className)}
                {...props}
            />
            {error ? (
                <p id={`${id}-error`} className='text-xs text-rose-300'>{error}</p>
            ) : hint ? (
                <p id={`${id}-hint`} className='text-xs text-muted-foreground'>{hint}</p>
            ) : null}
        </div>
    )
}

export default Field
